import { MerchantId, SetHeaderService } from "@/helper/userHelper";
import service from "../baseHttpService";

class UserService {
  DoGetUserDetailForDisplay(userIdList: any) {
    return service.peakExportAPI
      .post(
        "/api/User/GetUserDetailListForDisplay",
        {
          merchantId: MerchantId(),
          userIdList: userIdList,
        },
        SetHeaderService()
      )
      .then((res: any) => {
        return {
          responseCode: res.data.responseCode,
          userDetailList: this.ConvertToUserDetailList(res.data.userDetailList),
        };
      })
      .catch((err: any) => err);
  }

  ConvertToUserDetailList(userDetailRawList: any) {
    const userDetailList = [];
    if (userDetailRawList && userDetailRawList.length > 0) {
      for (const userDetailRaw of userDetailRawList) {
        userDetailList.push({
          userId: userDetailRaw.userId,
          userEmail: userDetailRaw.userEmail,
          userType: userDetailRaw.userType,
          signatureUrl: userDetailRaw.signatureUrl,
          displayName: userDetailRaw.displayName,
          accountingFirmId: userDetailRaw.accountingFirmId,
          phone: userDetailRaw.phone,
          pictureUrl: userDetailRaw.pictureUrl,
          userName: userDetailRaw.userName,
          firstName: userDetailRaw.firstName,
          lastName: userDetailRaw.lastName,
        });
      }
    }
    return userDetailList;
  }

  DoSendVideoFeedback(input: any) {
    return service.peakExportAPI
      .post("/api/User/UserFeedbackVideo", input, SetHeaderService())
      .then((res) => {
        return res.data;
      })
      .catch((err: any) => err);
  }
  DoGetVideoFeedback(input: any) {
    return service.peakExportAPI
      .post("/api/User/GetUserFeedbackVideo", input, SetHeaderService())
      .then((res) => {
        return res.data;
      })
      .catch((err: any) => err);
  }

  DoVerifyPINCode(input: any) {
    return service.peakAuthen
      .post("/User/VerifyPINCode", input, SetHeaderService())
      .then((res: any) => {
        return res;
      })
      .catch((err: any) => err);
  }
}
export default new UserService();
